import { render, staticRenderFns } from "./SlottedMessage.vue?vue&type=template&id=62891025&"
import script from "./SlottedMessage.vue?vue&type=script&lang=js&"
export * from "./SlottedMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports